import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Reports from "@/pages/Reports";
import Inventory from "@/pages/Inventory";
import ViewerPage from "@/pages/ViewerPage";
import RecipeCalculator from "@/pages/RecipeCalculator";
import { AuthProvider, useAuth, BASENAME } from "@/context/AuthContext";

function ProtectedRoute({ children, adminOnly = false }) {
  const { token, isViewer, loading } = useAuth();
  if (loading) return null;
  if (!token) return <Navigate to="/login" replace />;
  if (adminOnly && isViewer) return <Navigate to="/viewer" replace />;
  return children;
}

function ViewerRoute({ children }) {
  const { token, isViewer, loading } = useAuth();
  if (loading) return null;
  if (!token) return <Navigate to="/login" replace />;
  // Admins can access /viewer too if they want to see the mobile view
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter basename={BASENAME}>
          <Toaster richColors position="top-right" />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute adminOnly>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/viewer"
              element={
                <ViewerRoute>
                  <ViewerPage />
                </ViewerRoute>
              }
            />
            <Route
              path="/rapoarte"
              element={
                <ProtectedRoute adminOnly>
                  <Reports />
                </ProtectedRoute>
              }
            />
            <Route
              path="/inventar"
              element={
                <ProtectedRoute adminOnly>
                  <Inventory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/calculator"
              element={
                <ProtectedRoute adminOnly>
                  <RecipeCalculator />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
